<template>
  <div>
    <div class="filter-container">
      <el-input size="medium" placeholder="Username" v-model="search" clearable debounce @input="changeInput()"
        :style="{ width: '300px', marginRight: '20px' }" />
      <el-button size="medium" type="primary" @click="handleSearch()">Search</el-button>
    </div>

    <el-table :data="list.slice(
      (listQuery.page - 1) * listQuery.limit,
      listQuery.page * listQuery.limit
    )
      " v-loading="listLoading" style="width: 100%;" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center' }">
      <el-table-column prop="username" label="Username"></el-table-column>
      <el-table-column prop="email" label="Email"></el-table-column>
      <el-table-column prop="last_login" label="Last Login Time">
        <template slot-scope="scope">
          <span>{{
            moment(scope.row.last_login).format("YYYY-MM-DD HH:mm")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Action">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-circle-plus addUser" @click="handleCreate"> </i>
        </template>

        <template slot-scope="{ row, $index }">
          <i class="el-icon-edit editUser" @click="handleUpdate(row)"> </i>
          <el-popconfirm title="Do you want to delete the user?" confirm-button-text="Yes" cancel-button-text="No"
            @onConfirm="handleDelete(row)">
            <i slot="reference" class="el-icon-delete delUser"> </i>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="ls-page">
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        @pagination="getDataList" />
    </div>

    <el-dialog :title="dialogStatus" :visible.sync="dialogFormVisible" @close="resetForm" width="40%">
      <el-form ref="userForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="userForm">
        <el-form-item label="Username" prop="username">
          <el-input v-model="temp.username" :disabled="dialogStatus === 'Update'" />
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="temp.email" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          Cancel
        </el-button>
        <el-button type="primary" @click="dialogStatus === 'Create' ? createData() : updateData()">
          Submit
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Pagination from "components/pagination";

import { getUserList, createUser, updateUser, deleteUser } from "network/user";

export default {
  name: "User",
  components: { Pagination },
  data() {
    return {
      search: "",
      type: "",
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },
      list: [],
      temp: {
        username: "",
        email: "",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      rules: {
        username: [
          {
            required: true,
            message: "Please input username.",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "Please input email.",
            trigger: ["blur", "change"],
          },
          {
            type: "email",
            message: "Please input the correct email address.",
            trigger: ["blur", "change"],
          },
        ],
      },
      moment: moment,
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.listLoading = false;
      getUserList()
        .then((data) => {
          this.listLoading = false;

          this.list = data.data;
          this.total = this.list.length;
        })
        .catch((err) => {
          this.$message.error("Interface error:get_user_list");
        });
    },
    changeInput() {
      if (this.search === "") {
        this.getDataList();
      }
    },
    handleSearch() {
      this.listLoading = false;
      getUserList()
        .then((data) => {
          if (data.status === 200) {
            this.listLoading = false;

            this.list = data.data;
            this.total = this.list.length;
          }
        })
        .then(() => {
          let newList = [];
          newList = this.list.filter((item, index) => {
            const username =
              item.username.toUpperCase().indexOf(this.search.toUpperCase()) !==
              -1;

            if (username) {
              return true;
            }
          });

          this.list = newList;
          this.total = newList.length;
        })
        .catch((err) => {
          this.$message.error("Interface error: get_user_list");
        });
    },
    resetForm() {
      this.temp = {
        username: "",
        email: "",
      };
      this.$nextTick(() => {
        if (this.$refs["userForm"]) {
          this.$refs["userForm"].clearValidate();
        }
      });
    },
    handleCreate() {
      this.dialogStatus = "Create";
      this.dialogFormVisible = true;
    },
    createData() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          createUser(this.temp).then((data) => {
            console.log(data);
            if (data.status === 201) {
              this.getDataList();

              this.dialogFormVisible = false;

              this.$message({
                message: "Created Successfully.",
                type: "success",
              });
            }
          });
        }
      });
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = "Update";
      this.dialogFormVisible = true;
    },
    updateData() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          updateUser(tempData.id, tempData).then((data) => {
            if (data.status === 200) {
              this.getDataList();

              this.dialogFormVisible = false;

              this.$message({
                message: "Updated Successfully.",
                type: "success",
              });
            }
          });
        }
      });
    },
    handleDelete(row) {
      deleteUser(row.id).then((data) => {
        if (data.status === 204) {
          this.getDataList();

          this.$message({
            message: "Delete Successfully.",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.ls-page {
  float: right;
}

.addUser {
  font-size: 32px;
  cursor: pointer;
}

.editUser {
  font-size: 28px;
  cursor: pointer;
}

.delUser {
  margin-left: 10px;
  font-size: 28px;
  cursor: pointer;
  color: red;
}

.userForm .el-select {
  width: 100%;
}
</style>
